import React, { useState, useEffect } from 'react'
import styles from '../../../Css/CustomSettings.module.css'
import Styles from '../../../Css/UploadScreen.module.css'
import axios from 'axios'
import { Modal } from 'react-bootstrap'


function CustomWalls(props) {

  const cookie = key => ((new RegExp((key || '=') + '=(.*?); ', 'gm')).exec(document.cookie + '; ') || ['', null])[1]
  const [wallLength, setWallLength] = useState(4)

  useEffect(() => {
    if (props.wallData.length > 4) {
      setWallLength(3)
    }
    else {
      setWallLength(4)
    }
  }, [props.wallData.length])

  let fileInput;
  const [delWall, setDelWall] = useState(false)
  const [wallPlace, setWallPlace] = useState(null)

  const delWallShowModal = (e) => {
    setDelWall(true)
    setWallPlace(e)
  }

  const handleUpload = (event) => {

    let auth_token = cookie('auth_token')
    let enterprise_id = cookie('enterpriseId')
    if (auth_token == null) {
      auth_token = 'fe4a909f-9e2f-461f-98fc-51c22a21aac6'
    }
    const fd = new FormData();
    fd.append("image", event.target.files[0]);
    fd.append("optimization", false)
    console.log(event.target.files[0])
    axios({
      'method': 'POST',
      "url": process.env.REACT_APP_BASEURL + '/upload',
      "params": { 'api_key': "fde46c58-5735-4fcf-8b38-980c95001dc3" },
      "data": fd
    }).then((res) => {

      const wallfd = new FormData();
      wallfd.append("wall_name", event.target.files[0]["name"].split('.')[0])
      wallfd.append("wall_png_url", res?.data.image)
      wallfd.append("auth_key", auth_token)
      wallfd.append("category", "cat_d8R14zUNE")
      axios({
        'method': 'POST',
        "url": process.env.REACT_APP_BASEURL + '/v2/backgrounds/customWall-upload',
        "data": wallfd
      }).then((wall_output) => {
        const temp = {
          low_res_wall_url: wall_output.data.low_res_wall_url,
          wall_id: wall_output.data.wall_id,
          wall_name: wall_output.data.wall_name,
          wall_png_url: wall_output.data.wall_png_url
        }
        let temp_wall_data = props.wallData
        temp_wall_data.unshift(temp)
        props.setWallData([...temp_wall_data])

      })
    })
  }

  const delWallapi = (e) => {
    if (e) {
      var auth_key = cookie('auth_token')
      var wall = props.wallData[wallPlace]
      var wall_id = wall["wall_id"]
      const wallfd = new FormData();

      wallfd.append("wall_Id", wall_id);
      wallfd.append("auth_key", auth_key)
      axios({
        'method': 'POST',
        "url": process.env.REACT_APP_BASEURL + '/v2/backgrounds/customWall-delete',
        "data": wallfd
      }).then((res) => {
        if (res.data.status_code == 200) {
          let temp_wall_data = props.wallData
          temp_wall_data.shift()
          props.setWallData([...temp_wall_data])


        }
      })
    }
    setDelWall(false)
  }
  return (

    <div className={[styles['main-bg-row'], 'row m-0'].join(' ')}>
      <div className={[styles['custom-walls-area'], 'col-md-12'].join(' ')}>
        <div className={[styles['adjust-height'], 'row'].join(' ')}>
          <p><span>1</span> Choose a Wall </p>
        </div>
        <div className={[styles['background-list'], styles['custom-background-list'], ''].join(' ')}>
          <div className={styles['backgrounds-grid-custom']}>
            {props.isLoggedIn ?
              <div className={styles['inactive-walls-sec']}  >
                <input
                  type="file"
                  className="d-none"
                  onChange={(e) => handleUpload(e)}
                  ref={(file) => (fileInput = file)}
                />
                <img
                  src="https://storage.googleapis.com/spyne-website/static/website-themes/clippr/static/upload-rect.png"
                  onClick={() => fileInput.click()}
                />
                <span>Custom</span>
              </div>
              : null
            }
            {

              props.wallData.slice(0, wallLength).map((e, i) => {

                return (
                  <div key={i + "customwall"} className={props.customWall == e["wall_png_url"] ? styles['active-walls-sec'] : styles['inactive-walls-sec']} onClick={() => props.setCustomWall(e["wall_png_url"])} >
                    <img src={e["low_res_wall_url"]} ></img>
                    <span>{e["wall_name"].substring(0, 10)}</span>
                    {
                      e["wall_id"].split('-')[0] == "WL" ?
                        <img className={styles['wall-cross']} onClick={() => delWallShowModal(i)} src="https://storage.googleapis.com/spyne-website/static/website-themes/clippr/static/BackgroundReplacement/bulkprocessingv2/cross.svg" />
                        :
                        null
                    }
                  </div>
                )

              })
            }
            {props.wallData.length > 4 ?
              <div className={[styles['spyne-image'], 'solid-image'].join(' ')} onClick={props.handleBackgroundList}>
                <img src="https://storage.googleapis.com/spyne-website/self-serve/Automobile/more-bg.png" />
                <h6>+ more</h6>
              </div>
              : null
            }

          </div>
        </div>
        <div className={[styles['adjust-height'], 'row'].join(' ')}>
          <p><span>2</span> Adjust Height</p>
          <div className={[styles['adjust-height-area'], ''].join(' ')}>
            <ul>
              <li>
                <button className={props.applyWay === "manually" ? [styles['active'], ''].join(' ') : [styles['inactive'], ''].join(' ')} onClick={() => props.setApplyWay("manually")} >
                  <h6>Manually</h6>
                  <img src={props.applyWay == "manually" ? "https://storage.googleapis.com/spyne-website/static/website-themes/clippr/static/ezgif.com-gif-maker%20(3).gif" : "https://storage.googleapis.com/spyne-website/static/website-themes/clippr/static/auto-slidr.png"} />
                </button>
              </li>
              <li>
                <button className={props.applyWay === "magically" ? [styles['active'], ''].join(' ') : [styles['inactive'], ''].join(' ')} onClick={() => props.setApplyWay("magically")} >
                  <h6>Magically</h6>
                  <img src={props.applyWay == "magically" ? "https://storage.googleapis.com/spyne-website/static/website-themes/clippr/static/auto-setting.gif" : "https://storage.googleapis.com/spyne-website/static/website-themes/clippr/static/animation_500_kov5rgmo%201.png"} />
                </button>
              </li>
            </ul>
          </div>
        </div>
        <div className={[styles['adjust-height'], 'row'].join(' ')}>
          <p><span>3</span>Apply and View Changes</p>
          <div className={[styles['enhancements-custom-wall'], ''].join(' ')}>
            <div className={[styles['bg-blurr'], 'col-md-6 col-6 bg-blurr'].join(' ')}>
              <input type="checkbox" id="window" name="Correction" onClick={() => props.setGreyScale(!props.greyScale)} checked={props.greyScale} />
              <label htmlFor="window">Grey Scale</label>
            </div>
            <div className={[styles['bg-blurr'], 'col-md-6 col-6 bg-blurr'].join(' ')}>
              <input type="checkbox" id="color" name="Enhancements" onChange={props.handleColorEnhancement} checked={props.checkColorEnhancement} />
              <label htmlFor="color"> Colour Enhancements</label>
            </div>
          </div>
        </div>
        <Modal
          show={delWall}
          dialogClassName="modal-90w"
          aria-labelledby="example-custom-modal-styling-title"
          size='lg'
          centered
          onHide={() => this.setState({ delWall: !this.state.delWall })}
        >
          <Modal.Header />
          <Modal.Body>
            <center className={[styles['car-text']]}>
              <h1>Are you sure you want to Delete this <span style={{ color: "#FF7700" }}>CustomWall</span></h1>
            </center>

            <center>
              <button onClick={() => delWallapi(true)} className={styles['got-btn']}>Yes</button>
              <button onClick={() => delWallapi(false)} className={styles['got-btn']}>No</button>
            </center>

          </Modal.Body>
        </Modal>
      </div>
    </div>
  )
}

export default CustomWalls
